export default __webpack_public_path__ + "static/media/objects-manual.b87e5dc9.svg";